import { render, staticRenderFns } from "./listView.vue?vue&type=template&id=2f00fb0a&scoped=true"
import script from "./listView.vue?vue&type=script&lang=js"
export * from "./listView.vue?vue&type=script&lang=js"
import style0 from "./listView.vue?vue&type=style&index=0&id=2f00fb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00fb0a",
  null
  
)

export default component.exports